export type ChangeConfig =
  | ProfileChangeConfig
  | ProfilesRepeaterConfig
  | AssetChangeConfig
  | QuoteChangeConfig
  | StartDateChangeConfig
  | VoluntaryExcessChangeConfig
  | RequestCoverOptionChangeConfig

export enum ChangeType {
  ASSET_DISCLOSURE = 'ASSET_DISCLOSURE',
  PROFILE_DISCLOSURE = 'PROFILE_DISCLOSURE',
  PROFILES_REPEATER = 'PROFILES_REPEATER',
  POLICYHOLDER_DISCLOSURE = 'POLICYHOLDER_DISCLOSURE',
  START_DATE_CHANGE = 'START_DATE_CHANGE',
  VOLUNTARY_EXCESS = 'VOLUNTARY_EXCESS',
  REQUEST_COVER_OPTION = 'REQUEST_COVER_OPTION',
}

export interface UpdateChange {
  update: AdjustmentUpdate
}

export interface QuoteChangeConfig extends UpdateChange {
  changeType: ChangeType.POLICYHOLDER_DISCLOSURE
  update: AdjustmentUpdate
}

export interface ProfilesRepeaterConfig {
  changeType: ChangeType.PROFILES_REPEATER
  adjustments: string[]
}

export interface ProfileChangeConfig {
  changeType: ChangeType.PROFILE_DISCLOSURE
  update: AdjustmentUpdate
}

export interface AssetChangeConfig {
  changeType: ChangeType.ASSET_DISCLOSURE
  update: AdjustmentUpdate
}

export interface StartDateChangeConfig {
  changeType: ChangeType.START_DATE_CHANGE
}

export interface VoluntaryExcessChangeConfig {
  changeType: ChangeType.VOLUNTARY_EXCESS
  excessCode: string
}

export interface RequestCoverOptionChangeConfig {
  changeType: ChangeType.REQUEST_COVER_OPTION
  coverCode: string
}

export interface Update {
  path: string
  attribute?: boolean
  policyholderPath?: string
}

export interface NestedUpdate extends Update {
  id: string
}

export type AdjustmentUpdate = Update | Array<NestedUpdate>
